import { AITextGeneration, AITextGenerationType } from '../../AITextGeneration'
import { Container } from '../Container'

import * as styles from './AITextGeneration.module.css'

function AITextGenerationLibrary() {
  return (
    <>
      <Container>
        <AITextGeneration
          className={styles.form}
          type={AITextGenerationType.Email}
        />
      </Container>
      <Container>
        <AITextGeneration
          isLoading
          className={styles.form}
          type={AITextGenerationType.Email}
        />
      </Container>
    </>
  )
}

export default AITextGenerationLibrary
